// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-1d695b71] .el-date-editor .el-range-separator {\n  width: 7%;\n}\n", ""]);
// Exports
module.exports = exports;
